import React from 'react'
import PropTypes from 'prop-types'
import WhiteThemeProvider from '../WhiteThemeProvider'

const withWhiteTheme = WrappedComponent => {
	return props => (
		<WhiteThemeProvider>
			<WrappedComponent {...props} />
		</WhiteThemeProvider>
	)
}

withWhiteTheme.propTypes = {
	WrappedComponent: PropTypes.elementType.isRequired,
}

export default withWhiteTheme
